// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App Container */
.app-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 20px;
}

/* Common Layout */
.taskpane {
  padding: 10px 10px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
}

.taskpane-header {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #edebe9;
}

.taskpane-header h2 {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #323130;
}

.taskpane-header .subtitle {
  font-size: 12px;
  color: #605e5c;
  margin: 0;
}

/* Sections */
.section {
  margin-bottom: 16px;
}

.section-title {
  font-size: 12px;
  font-weight: 600;
  color: #605e5c;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

/* Info List */
.info-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.info-label {
  font-size: 11px;
  color: #8a8886;
  text-transform: uppercase;
}

.info-value {
  font-size: 13px;
  color: #323130;
  word-break: break-word;
}

/* Status Badge */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.elaboracao {
  background-color: #fff4ce;
  color: #8a6914;
}

.status-badge.revisao {
  background-color: #cfe4ff;
  color: #0f6cbd;
}

.status-badge.concluido {
  background-color: #dff6dd;
  color: #107c10;
}

/* Warning/Info Boxes */
.warning-box {
  background-color: #fff4ce;
  border-left: 4px solid #ffb900;
  padding: 12px;
  margin-bottom: 16px;
}

.warning-box h3 {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 600;
  color: #8a6914;
}

.warning-box p {
  margin: 0;
  font-size: 13px;
  color: #323130;
}

.info-box {
  background-color: #f3f2f1;
  border-left: 4px solid #8a8886;
  padding: 12px;
  margin-bottom: 16px;
}

.info-box h3 {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 600;
  color: #323130;
}

.info-box p {
  margin: 0;
  font-size: 13px;
  color: #605e5c;
}

/* Error Box */
.error-box {
  background-color: #fde7e9;
  border-left: 4px solid #d13438;
  padding: 12px;
  margin-bottom: 16px;
}

.error-box h3 {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 600;
  color: #a4262c;
}

.error-box p {
  margin: 0;
  font-size: 13px;
  color: #323130;
}

/* Form */
.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #323130;
  margin-bottom: 4px;
}

.form-error {
  color: #a4262c;
  font-size: 12px;
  margin-top: 4px;
}

/* Actions */
.actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
}

.actions-row {
  display: flex;
  gap: 8px;
}

/* Muted text */
.muted {
  color: #8a8886;
  font-size: 12px;
}

/* Help text */
.help-text {
  background-color: #f3f2f1;
  padding: 12px;
  border-radius: 4px;
  font-size: 12px;
  color: #605e5c;
  margin-top: 16px;
}

/* AI Assistant */
.ai-assistant {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.result-box {
  background-color: #f3f2f1;
  border-radius: 4px;
  padding: 12px;
}

.result-box textarea {
  width: 100%;
  font-size: 13px;
}

/* Correction Preview */
.correction-preview {
  background-color: #f3f2f1;
  border-radius: 4px;
  padding: 12px;
}

.correction-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}

.correction-title {
  font-size: 13px;
  font-weight: 600;
  color: #323130;
}

.correction-summary {
  font-size: 11px;
  color: #605e5c;
}

.correction-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
}

.correction-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #edebe9;
  cursor: pointer;
  transition: background-color 0.15s;
}

.correction-item:hover {
  background-color: #f5f5f5;
}

.correction-item.invalid {
  opacity: 0.7;
  cursor: not-allowed;
  background-color: #fde7e9;
  border-color: #d13438;
}

.correction-item.valid {
  border-left: 3px solid #107c10;
}

.correction-content {
  flex: 1;
  min-width: 0;
}

.correction-text {
  font-size: 13px;
  color: #323130;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.correction-text .original {
  background-color: #fde7e9;
  color: #a4262c;
  padding: 2px 6px;
  border-radius: 3px;
  text-decoration: line-through;
}

.correction-text .arrow {
  color: #8a8886;
  font-size: 12px;
}

.correction-text .corrected {
  background-color: #dff6dd;
  color: #107c10;
  padding: 2px 6px;
  border-radius: 3px;
}

.correction-meta {
  margin-top: 4px;
  font-size: 11px;
}

.correction-meta .meta-valid {
  color: #605e5c;
}

.correction-meta .meta-invalid {
  color: #a4262c;
}

.correction-info {
  padding: 8px;
  background-color: #c0e8d0;
  border-radius: 4px;
}

.correction-actions {
  padding-top: 8px;
  border-top: 1px solid #edebe9;
}

/* Modal-specific styles */
.correction-list-modal {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px;
}

.correction-list-modal .correction-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background-color: #fafafa;
  border-radius: 6px;
  border: 1px solid #edebe9;
  cursor: pointer;
  transition: all 0.15s;
}

.correction-list-modal .correction-item:hover {
  background-color: #f0f0f0;
  border-color: #d0d0d0;
}

.correction-list-modal .correction-item.valid {
  border-left: 4px solid #107c10;
}

.correction-list-modal .correction-item.invalid {
  opacity: 0.8;
  cursor: not-allowed;
  background-color: #fff5f5;
  border-color: #f0c0c0;
}

.correction-list-modal .correction-text {
  font-size: 14px;
  gap: 8px;
}

.correction-list-modal .correction-text .original {
  padding: 4px 8px;
  font-size: 13px;
}

.correction-list-modal .correction-text .corrected {
  padding: 4px 8px;
  font-size: 13px;
}

.correction-list-modal .correction-meta {
  margin-top: 6px;
  font-size: 12px;
}

/* Correction options (Track Changes checkbox) */
.correction-options {
  background-color: #f8f8f8;
  border-radius: 4px;
  padding: 8px 12px;
}

/* Tab Container - Underline minimalist */
.tab-container {
  margin: 0 0 8px 0;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tab-logo {
  height: 28px;
  width: auto;
  opacity: 0.7;
  margin-right: 16px;
  flex-shrink: 0;
}

.tab-container [role="tablist"] {
  gap: 0;
}

.tab-container [role="tab"] {
  border-radius: 0;
  padding: 10px 16px;
  font-weight: 500;
  font-size: 13px;
  color: #8a8886;
  transition: all 0.15s ease;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  background: none;
}

.tab-container [role="tab"]:hover {
  background-color: transparent;
  color: #485550;
  border-bottom-color: #c8d5cc;
}

.tab-container [role="tab"][aria-selected="true"] {
  background-color: transparent;
  color: #009640;
  border-bottom-color: #009640;
  font-weight: 600;
  box-shadow: none;
}

.tab-container [role="tab"] svg,
.tab-container [role="tab"] span {
  color: inherit !important;
}

/* Hide Fluent UI's built-in tab indicator */
.tab-container [role="tab"]::after {
  display: none !important;
}

.tab-content {
  flex: 1;
  overflow-y: auto;
}

/* Tools Tab */
.tools-tab {
  display: flex;
  flex-direction: column;
}

/* Process Data Tab */
.process-data-tab {
  display: flex;
  flex-direction: column;
}

/* Chat Tab */
.chat-tab {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);
  min-height: 0; /* Allow flex children to shrink */
}

.chat-messages {
  flex: 1 1 0;
  overflow-y: auto;
  padding: 8px 4px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0; /* Critical for flex scroll */
  margin-bottom: 8px;
  border-bottom: 1px solid #d8e2db;
}

/* Cards inside chat should not have internal scroll limits */
.chat-messages .analysis-result-card,
.chat-messages .tool-response-block {
  flex-shrink: 0; /* Prevent cards from shrinking */
}

.chat-empty {
  text-align: center;
  padding: 16px;
  color: #8a8886;
  font-size: 12px;
}

.chat-empty p {
  margin: 0;
}

.chat-message {
  display: flex;
  flex-direction: column;
  padding: 10px 14px;
  border-radius: 12px;
  max-width: 85%;
}

.chat-message.user {
  align-self: flex-end;
  background-color: #009640;
  color: #fff;
  border-bottom-right-radius: 4px;
}

.chat-message.assistant {
  align-self: flex-start;
  background-color: #f3f2f1;
  color: #323130;
  border-bottom-left-radius: 4px;
}

.chat-message-content {
  font-size: 13px;
  line-height: 1.4;
  word-break: break-word;
}

/* Only apply pre-wrap to user messages (plain text) */
.chat-message.user .chat-message-content {
  white-space: pre-wrap;
}

.chat-message-time {
  font-size: 10px;
  opacity: 0.7;
  margin-top: 4px;
  align-self: flex-end;
}

.chat-input-area {
  padding: 8px 12px 10px 12px;
  background: linear-gradient(135deg, #f2f7f4 0%, #e8f0eb 100%);
  border-radius: 12px;
  margin-top: 4px;
}

.chat-input-resize-handle {
  height: 10px;
  cursor: ns-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  transition: background-color 0.15s;
  margin-bottom: 4px;
  border-radius: 6px;
}

.chat-input-resize-handle::after {
  content: "";
  width: 40px;
  height: 3px;
  background-color: #c0cec4;
  border-radius: 2px;
  transition: background-color 0.15s;
}

.chat-input-resize-handle:hover {
  background-color: rgba(0, 150, 64, 0.1);
}

.chat-input-resize-handle:hover::after {
  background-color: #009640;
}

.chat-input-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.chat-input-row textarea,
.chat-input-row .fui-Textarea {
  resize: none;
  min-height: 36px;
  max-height: 300px;
  border-radius: 10px !important;
  border-color: #c8d5cc !important;
  background-color: #fff !important;
}

.chat-input-row textarea:focus,
.chat-input-row .fui-Textarea:focus-within {
  border-color: #009640 !important;
  box-shadow: 0 0 0 1px rgba(0, 150, 64, 0.2) !important;
}

.chat-buttons {
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
}

.chat-buttons button {
  border-radius: 8px !important;
  transition: all 0.15s ease !important;
}

/* Send button - brand green */
.chat-buttons button[data-fui-focus-visible] {
  outline-color: #009640 !important;
}

.chat-buttons > span:first-child button {
  background-color: #009640 !important;
  border-color: #009640 !important;
}

.chat-buttons > span:first-child button:hover:not(:disabled) {
  background-color: #007A33 !important;
  border-color: #007A33 !important;
}

.chat-buttons > span:first-child button:disabled {
  background-color: #c0cec4 !important;
  border-color: #c0cec4 !important;
}

/* Chat Selection Preview */
.chat-selection-preview {
  background-color: #f8faf9;
  border: 1px solid #c8d5cc;
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 8px;
}

.chat-selection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  color: #607060;
  margin-bottom: 6px;
}

.chat-selection-text {
  font-size: 12px;
  color: #323130;
  line-height: 1.4;
  max-height: 80px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Markdown Content in Chat - compact styling */
.markdown-content {
  font-size: 13px;
  line-height: 1.4;
}

/* Reset base margins */
.markdown-content p,
.markdown-content ul,
.markdown-content ol,
.markdown-content h1,
.markdown-content h2,
.markdown-content h3,
.markdown-content h4,
.markdown-content h5,
.markdown-content h6 {
  margin: 0;
  padding: 0;
}

/* Paragraphs */
.markdown-content p {
  margin-bottom: 0.5em;
}

/* Lists */
.markdown-content ul,
.markdown-content ol {
  padding-left: 1.5em;
  margin: 0.5em 0;
  list-style-position: outside;
}

.markdown-content li {
  margin-bottom: 0.4em;
  padding-left: 0.3em;
}

/* Nested lists (bullets) - more indentation */
.markdown-content li > ul,
.markdown-content li > ol {
  margin: 0.2em 0;
  padding-left: 1.8em;
}

/* Headings */
.markdown-content h1,
.markdown-content h2,
.markdown-content h3 {
  font-weight: 600;
  margin: 0.6em 0 0.3em 0;
}

.markdown-content h1 { font-size: 15px; }
.markdown-content h2 { font-size: 14px; }
.markdown-content h3 { font-size: 13px; }

/* Code */
.markdown-content code {
  background-color: rgba(0, 0, 0, 0.08);
  padding: 1px 4px;
  border-radius: 3px;
  font-family: "Consolas", "Monaco", monospace;
  font-size: 12px;
}

.markdown-content pre {
  background-color: rgba(0, 0, 0, 0.08);
  padding: 8px;
  border-radius: 4px;
  overflow-x: auto;
  margin: 0.5em 0;
}

.markdown-content pre code {
  background: none;
  padding: 0;
}

/* Other elements */
.markdown-content blockquote {
  border-left: 3px solid #8a8886;
  margin: 0.5em 0;
  padding-left: 10px;
  color: #605e5c;
}

.markdown-content strong { font-weight: 600; }
.markdown-content em { font-style: italic; }

.markdown-content a {
  color: #009640;
  text-decoration: none;
}

.markdown-content a:hover {
  text-decoration: underline;
}

.markdown-content hr {
  border: none;
  border-top: 1px solid #edebe9;
  margin: 0.5em 0;
}

.markdown-content table {
  border-collapse: collapse;
  width: 100%;
  margin: 0.5em 0;
  font-size: 12px;
}

.markdown-content th,
.markdown-content td {
  border: 1px solid #edebe9;
  padding: 4px 6px;
  text-align: left;
}

.markdown-content th {
  background-color: rgba(0, 0, 0, 0.05);
  font-weight: 600;
}

/* Clickable citations [[text]] */
.chat-citation {
  background-color: #e0f2e8;
  color: #009640;
  padding: 1px 4px;
  border-radius: 3px;
  cursor: pointer;
  border-bottom: 1px dashed #009640;
  transition: background-color 0.15s, color 0.15s;
}

.chat-citation:hover {
  background-color: #c0e8d0;
  color: #007A33;
}

.chat-citation:active {
  background-color: #a0d8b8;
}

/* Quick Actions - Chip style */
.chat-quick-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 4px 0;
  margin-bottom: 6px;
}

.quick-action-btn {
  border-radius: 20px !important;
  font-weight: 500 !important;
  font-size: 11px !important;
  transition: all 0.15s ease !important;
  background-color: transparent !important;
  border-color: #d8ddd9 !important;
  color: #606060 !important;
  padding: 3px 10px !important;
  min-width: 0 !important;
}

.quick-action-btn:hover:not(:disabled) {
  background-color: #f0f5f2 !important;
  border-color: #009640 !important;
  color: #009640 !important;
}

.quick-action-btn:disabled {
  opacity: 0.4 !important;
}

.quick-action-btn.active {
  background-color: #e6f4ec !important;
  border-color: #009640 !important;
  color: #009640 !important;
  font-weight: 600 !important;
}

.quick-action-btn.active:hover:not(:disabled) {
  background-color: #d4eddf !important;
  border-color: #007A33 !important;
  color: #007A33 !important;
}

/* Analysis Result Card */
.analysis-result-card {
  background-color: #f8faf9;
  border: 1px solid #d8e2db;
  border-radius: 10px;
  overflow: hidden;
  margin: 8px 0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.analysis-result-card.collapsed {
  border-color: #d8e2db;
}

.analysis-result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: linear-gradient(135deg, #e8f0eb 0%, #d8e2db 100%);
  cursor: pointer;
  user-select: none;
  transition: background 0.15s;
}

.analysis-result-header:hover {
  background: linear-gradient(135deg, #d8e2db 0%, #d0ddd4 100%);
}

.analysis-result-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #485550;
}

.analysis-result-title svg {
  color: #607060;
}

.analysis-result-time {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 400;
  color: #8a8886;
  margin-left: 4px;
}

.analysis-result-time svg {
  width: 12px;
  height: 12px;
}

.analysis-result-toggle {
  color: #8a8886;
  display: flex;
  align-items: center;
}

.analysis-result-preview {
  padding: 8px 14px;
  font-size: 11px;
  color: #605e5c;
  background-color: #f8faf9;
  border-top: 1px solid #e8f0eb;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Analysis Section */
.analysis-section {
  border-top: 1px solid #e8f0eb;
}

.analysis-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background-color: #f8faf9;
  cursor: pointer;
  user-select: none;
}

.analysis-section-header:hover {
  background-color: #f2f7f4;
}

.analysis-section-toggle {
  color: #7a8a80;
  display: flex;
  align-items: center;
}

.analysis-section-title {
  font-size: 12px;
  font-weight: 500;
  color: #485550;
}

/* Apply All button - brand green */
.analysis-apply-all-btn {
  background-color: #009640 !important;
  border-color: #009640 !important;
  color: #fff !important;
}

.analysis-apply-all-btn:hover {
  background-color: #007A33 !important;
  border-color: #007A33 !important;
}

.analysis-apply-all-btn:active {
  background-color: #006528 !important;
  border-color: #006528 !important;
}

.analysis-section-content {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 12px;
  background-color: #fff;
}

/* paragraph-groups inside analysis-section - no internal scroll, grows naturally */
.analysis-section-content.paragraph-groups {
  padding: 12px;
  padding-bottom: 8px;
  /* No max-height - scroll is at chat level */
}

/* Custom scrollbar for chat messages area */
.chat-messages::-webkit-scrollbar {
  width: 8px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #e8f0eb;
  border-radius: 4px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #b8c8be;
  border-radius: 4px;
  min-height: 40px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #98b0a0;
}

/* Analysis Item (generic) */
.analysis-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  margin-bottom: 8px;
  background-color: #fafafa;
  border-radius: 6px;
  border-left: 3px solid #e0e0e0;
}

.analysis-item.erro {
  border-left-color: #d13438;
}

.analysis-item.melhoria {
  border-left-color: #498205;
}

.analysis-item:last-child {
  margin-bottom: 0;
}

.analysis-item.applied {
  opacity: 0.5;
  background-color: #f0fff0;
}

.analysis-item-content {
  flex: 1;
  min-width: 0;
}

/* Type badge (erro/melhoria) - elegant pill style */
.analysis-type-badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 2px 8px;
  border-radius: 10px;
}

.analysis-type-badge.erro {
  color: #fff;
  background: linear-gradient(135deg, #d13438, #a4262c);
}

.analysis-type-badge.melhoria {
  color: #fff;
  background: linear-gradient(135deg, #498205, #107c10);
}

/* Count badges in section header - pill style */
.analysis-count-badge {
  display: inline-block;
  font-size: 9px;
  font-weight: 600;
  margin-left: 6px;
  padding: 2px 6px;
  border-radius: 8px;
}

.analysis-count-badge.erro {
  color: #fff;
  background-color: #d13438;
}

.analysis-count-badge.melhoria {
  color: #fff;
  background-color: #498205;
}

.analysis-correction-text {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  flex-wrap: wrap;
}

.analysis-correction-text .original {
  background-color: #fde7e9;
  color: #a4262c;
  padding: 2px 6px;
  border-radius: 3px;
  text-decoration: line-through;
}

.analysis-correction-text .arrow {
  color: #8a8886;
}

.analysis-correction-text .corrected {
  background-color: #dff6dd;
  color: #107c10;
  padding: 2px 6px;
  border-radius: 3px;
}

.applied-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #107c10;
  font-weight: 600;
  font-size: 14px;
}

.analysis-item-toggle {
  color: #8a8886;
  display: flex;
  align-items: center;
}

.analysis-item-preview {
  font-size: 12px;
  color: #323130;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-item-details {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #edebe9;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.analysis-detail-row {
  font-size: 12px;
  color: #323130;
  line-height: 1.4;
}

.analysis-detail-row.muted {
  color: #605e5c;
}

.analysis-empty {
  text-align: center;
  padding: 16px;
  color: #8a8886;
  font-size: 12px;
}

/* Analysis List (style & legal sections) */
.analysis-list {
  list-style: none;
  margin: 0;
  padding: 8px 12px;
  background-color: #fff;
}

.analysis-list-item {
  font-size: 12px;
  color: #323130;
  line-height: 1.5;
  padding: 6px 0;
  border-bottom: 1px solid #f3f2f1;
}

.analysis-list-item:last-child {
  border-bottom: none;
}

.analysis-clickable {
  color: #009640;
  cursor: pointer;
  font-style: italic;
}

.analysis-clickable:hover {
  text-decoration: underline;
}

.analysis-suggestion {
  color: #107c10;
  font-weight: 500;
}

.analysis-reason {
  color: #605e5c;
  font-size: 11px;
}

.analysis-reference {
  color: #8a8886;
  font-size: 11px;
  font-style: italic;
}

/* Item header - badge + actions */
.analysis-item-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.analysis-item-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
}

/* Locate button - subtle icon */
.analysis-locate-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: #605e5c;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.15s ease;
}

.analysis-locate-btn:hover {
  background-color: #e1dfdd;
  color: #009640;
}

.analysis-locate-btn:active {
  background-color: #c8c6c4;
}

/* Explanation text - green highlight box */
.analysis-explanation {
  display: block;
  font-size: 11px;
  color: #2d5540;
  background-color: #e8f5ed;
  border-left: 2px solid #009640;
  padding: 6px 10px;
  margin-bottom: 8px;
  border-radius: 0 4px 4px 0;
}

/* Visual diff - indented with bracket style */
.analysis-diff-text {
  font-size: 12px;
  line-height: 1.6;
  color: #323130;
  padding-left: 12px;
  border-left: 2px solid #e0e0e0;
}

/* Diff highlights - deletions (red strikethrough) */
.analysis-diff-text del {
  color: #a4262c;
  background-color: #fde7e9;
  text-decoration: line-through;
  padding: 0 2px;
  border-radius: 2px;
}

/* Diff highlights - insertions (green) */
.analysis-diff-text ins {
  color: #107c10;
  background-color: #dff6dd;
  font-weight: 500;
  text-decoration: none;
  padding: 0 2px;
  border-radius: 2px;
}

/* ============================================
   Paragraph Groups - Grouped corrections view
   ============================================ */

.paragraph-groups {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.paragraph-group {
  background-color: #f8faf9;
  border-radius: 10px;
  border: 1px solid #d8e2db;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.paragraph-group.all-resolved {
  opacity: 0.7;
  background-color: #f8fbf8;
  border-color: #d4e8d4;
  box-shadow: none;
}

.paragraph-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f2f7f4 0%, #ebf1ed 100%);
  border-bottom: 1px solid #d8e2db;
}

.paragraph-group-title {
  font-size: 12px;
  font-weight: 600;
  color: #323130;
}

.paragraph-group-count {
  font-weight: 400;
  color: #605e5c;
  margin-left: 6px;
}

/* AI's explanation/summary for the paragraph */
.paragraph-group-resumo {
  font-size: 11px;
  color: #2d5540;
  background-color: #e8f5ed;
  padding: 8px 12px;
  border-bottom: 1px solid #d8e8dc;
}

/* Full paragraph diff display */
.paragraph-group-diff {
  font-size: 12px;
  line-height: 1.6;
  color: #323130;
  padding: 12px;
  background-color: #fff;
  border-bottom: 1px solid #e8e8e8;
}

.paragraph-group-diff del {
  color: #a4262c;
  background-color: #fde7e9;
  text-decoration: line-through;
  padding: 0 2px;
  border-radius: 2px;
}

.paragraph-group-diff ins {
  color: #107c10;
  background-color: #dff6dd;
  font-weight: 500;
  text-decoration: none;
  padding: 0 2px;
  border-radius: 2px;
}

/* Individual corrections container */
.paragraph-group-corrections {
  padding: 10px 14px;
  background-color: #f7f9f8;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 40px;
}

/* Compact row for each individual correction */
.compact-ajuste-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: linear-gradient(135deg, #f5fbf7 0%, #eef8f1 100%);
  border-radius: 6px;
  border: 1px solid #d8e8dc;
  box-shadow: 0 1px 3px rgba(0, 150, 64, 0.08);
  transition: all 0.2s ease;
  min-height: 36px;
}

.compact-ajuste-row:hover {
  border-color: #a8d4b8;
  box-shadow: 0 2px 6px rgba(0, 150, 64, 0.12);
}

.compact-ajuste-row.applied {
  opacity: 0.6;
  background: linear-gradient(135deg, #f8fcf8 0%, #f0f8f0 100%);
  border-color: #d4e8d4;
  box-shadow: none;
}

.compact-ajuste-number {
  font-size: 10px;
  color: #609070;
  font-weight: 600;
  min-width: 20px;
  flex-shrink: 0;
  text-align: center;
}

.compact-ajuste-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 4px;
  transition: background-color 0.15s ease;
}

.compact-ajuste-content:hover {
  background-color: rgba(0, 150, 64, 0.1);
}

.compact-ajuste-diff {
  font-size: 12px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
}

.compact-ajuste-motivo {
  font-size: 10px;
  color: #009640;
  font-style: italic;
  padding: 2px 6px;
  background-color: rgba(0, 150, 64, 0.08);
  border-radius: 3px;
  display: inline-block;
  margin-top: 2px;
}

.compact-ajuste-diff del {
  color: #a4262c;
  background-color: #fde7e9;
  text-decoration: line-through;
  padding: 0 2px;
  border-radius: 2px;
}

.compact-ajuste-diff ins {
  color: #107c10;
  background-color: #dff6dd;
  font-weight: 500;
  text-decoration: none;
  padding: 0 2px;
  border-radius: 2px;
}

.compact-ajuste-action {
  flex-shrink: 0;
}

.applied-badge-small {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: #107c10;
  font-size: 12px;
}

.rejected-badge-small {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: #a4262c;
  font-size: 12px;
}

.compact-ajuste-row.rejected {
  opacity: 0.5;
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
  border-color: #e0e0e0;
  box-shadow: none;
}

.compact-ajuste-row.rejected .compact-ajuste-diff {
  text-decoration: line-through;
  color: #999;
}

.compact-ajuste-row.rejected .compact-ajuste-diff del,
.compact-ajuste-row.rejected .compact-ajuste-diff ins {
  background: none;
  color: #999;
}

.rejected-count {
  color: #a4262c;
  font-size: 10px;
}

/* Validation error state */
.compact-ajuste-row.validation-error {
  background: linear-gradient(135deg, #fff8f0 0%, #ffefe0 100%);
  border-color: #f0c8a0;
  opacity: 0.85;
}

.compact-ajuste-validation-error {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #d83b01;
  font-size: 10px;
  margin-top: 4px;
}

.compact-ajuste-validation-error svg {
  flex-shrink: 0;
}

.validation-error-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 14px;
  cursor: help;
}

/* ============================================
   Tool Response Blocks (Redigir/Reescrever)
   ============================================ */

.tool-response-block {
  background-color: #f5f8f6;
  border: 1px solid #d0dbd4;
  border-radius: 10px;
  overflow: hidden;
  margin: 8px 0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.tool-response-block.collapsed {
  border-color: #d8e2db;
}

.tool-response-block.applied {
  background-color: #f6fbf6;
  border-color: #c8e0c8;
}

.tool-response-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: linear-gradient(135deg, #e8f0eb 0%, #d8e2db 100%);
  cursor: pointer;
  user-select: none;
  transition: background 0.15s;
}

.tool-response-header:hover {
  background: linear-gradient(135deg, #d8e2db 0%, #d0ddd4 100%);
}

.tool-response-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #3a4d40;
}

.tool-response-title svg {
  color: #009640;
}

.tool-response-time {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 400;
  color: #8a8886;
  margin-left: 8px;
}

.tool-response-time svg {
  width: 12px;
  height: 12px;
}

.tool-response-toggle {
  color: #8a8886;
  display: flex;
  align-items: center;
}

.tool-response-preview {
  padding: 8px 14px;
  font-size: 11px;
  color: #605e5c;
  background-color: #f8faf9;
  border-top: 1px solid #d8e8dc;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tool-response-content {
  padding: 14px;
  background-color: #fff;
  border-top: 1px solid #d8e2db;
}

.tool-response-input {
  font-size: 11px;
  color: #8a8886;
  margin-bottom: 10px;
  padding: 6px 10px;
  background-color: #f2f7f4;
  border-radius: 4px;
  border-left: 2px solid #a0c8b0;
}

.tool-response-input-label {
  font-weight: 600;
  margin-right: 6px;
  color: #605e5c;
}

.tool-response-input-text {
  color: #323130;
}

.tool-response-result {
  font-size: 13px;
  line-height: 1.6;
  color: #323130;
  white-space: pre-wrap;
  word-break: break-word;
  padding: 12px;
  background-color: #f7faf8;
  border-radius: 6px;
  border: 1px solid #d8e2db;
  max-height: 300px;
  overflow-y: auto;
}

.tool-response-html {
  white-space: normal;
}

.tool-response-html h1,
.tool-response-html h2,
.tool-response-html h3 {
  font-size: 13px !important;
  margin: 8px 0 4px 0;
  line-height: 1.4;
}

.tool-response-html h1 {
  font-weight: 700;
  text-transform: uppercase;
}

.tool-response-html h2 {
  font-weight: 600;
}

.tool-response-html p {
  font-size: 12px;
  line-height: 1.5;
  margin: 4px 0;
  text-indent: 0 !important;
}

.tool-response-html blockquote {
  font-size: 11px !important;
  margin: 6px 0 6px 12px;
  padding-left: 8px;
  border-left: 2px solid #d8e2db;
  color: #605e5c;
  font-style: italic;
}

.tool-response-html ol,
.tool-response-html ul {
  font-size: 12px;
  margin: 4px 0;
  padding-left: 20px;
}

.tool-response-html li {
  margin-bottom: 2px;
}

.tool-response-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #d8e2db;
}

/* Tool Mode Indicator */
.tool-mode-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: linear-gradient(135deg, #e0f0e8 0%, #c8e0d0 100%);
  border: 1px solid #009640;
  border-radius: 8px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #007030;
}

.tool-mode-indicator svg {
  flex-shrink: 0;
  color: #009640;
}

.tool-mode-indicator span {
  flex: 1;
}

.tool-mode-indicator button {
  flex-shrink: 0;
}

`, "",{"version":3,"sources":["webpack://./src/taskpane/App.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,eAAe;AACf;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB;AAC1B;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa,EAAE,kCAAkC;AACnD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa,EAAE,6BAA6B;EAC5C,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,6DAA6D;AAC7D;;EAEE,cAAc,EAAE,iCAAiC;AACnD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,sDAAsD;AACtD;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;;EAEE,gCAAgC;EAChC,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA,8BAA8B;AAC9B;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;;;;;;;;;EASE,SAAS;EACT,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,oBAAoB;AACtB;;AAEA,UAAU;AACV;;EAEE,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA,aAAa;AACb;;;EAGE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,uBAAuB,eAAe,EAAE;AACxC,uBAAuB,eAAe,EAAE;AACxC,uBAAuB,eAAe,EAAE;;AAExC,SAAS;AACT;EACE,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,2BAA2B,gBAAgB,EAAE;AAC7C,uBAAuB,kBAAkB,EAAE;;AAE3C;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;EACrC,wCAAwC;EACxC,gCAAgC;EAChC,yBAAyB;EACzB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,aAAa;EACb,sBAAsB;AACxB;;AAEA,mFAAmF;AACnF;EACE,aAAa;EACb,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,4CAA4C;AAC5C;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA,oDAAoD;AACpD;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,qDAAqD;AACvD;;AAEA,gDAAgD;AAChD;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,oDAAoD;AACpD;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;EACzB,4CAA4C;EAC5C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,6DAA6D;EAC7D,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,6DAA6D;EAC7D,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* App Container */\n.app-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  padding: 20px;\n}\n\n/* Common Layout */\n.taskpane {\n  padding: 10px 10px;\n  height: 100%;\n  box-sizing: border-box;\n  overflow-y: auto;\n}\n\n.taskpane-header {\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #edebe9;\n}\n\n.taskpane-header h2 {\n  margin: 0 0 4px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #323130;\n}\n\n.taskpane-header .subtitle {\n  font-size: 12px;\n  color: #605e5c;\n  margin: 0;\n}\n\n/* Sections */\n.section {\n  margin-bottom: 16px;\n}\n\n.section-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #605e5c;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n}\n\n/* Info List */\n.info-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.info-label {\n  font-size: 11px;\n  color: #8a8886;\n  text-transform: uppercase;\n}\n\n.info-value {\n  font-size: 13px;\n  color: #323130;\n  word-break: break-word;\n}\n\n/* Status Badge */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-badge.elaboracao {\n  background-color: #fff4ce;\n  color: #8a6914;\n}\n\n.status-badge.revisao {\n  background-color: #cfe4ff;\n  color: #0f6cbd;\n}\n\n.status-badge.concluido {\n  background-color: #dff6dd;\n  color: #107c10;\n}\n\n/* Warning/Info Boxes */\n.warning-box {\n  background-color: #fff4ce;\n  border-left: 4px solid #ffb900;\n  padding: 12px;\n  margin-bottom: 16px;\n}\n\n.warning-box h3 {\n  margin: 0 0 4px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #8a6914;\n}\n\n.warning-box p {\n  margin: 0;\n  font-size: 13px;\n  color: #323130;\n}\n\n.info-box {\n  background-color: #f3f2f1;\n  border-left: 4px solid #8a8886;\n  padding: 12px;\n  margin-bottom: 16px;\n}\n\n.info-box h3 {\n  margin: 0 0 4px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #323130;\n}\n\n.info-box p {\n  margin: 0;\n  font-size: 13px;\n  color: #605e5c;\n}\n\n/* Error Box */\n.error-box {\n  background-color: #fde7e9;\n  border-left: 4px solid #d13438;\n  padding: 12px;\n  margin-bottom: 16px;\n}\n\n.error-box h3 {\n  margin: 0 0 4px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #a4262c;\n}\n\n.error-box p {\n  margin: 0;\n  font-size: 13px;\n  color: #323130;\n}\n\n/* Form */\n.form-group {\n  margin-bottom: 16px;\n}\n\n.form-group label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #323130;\n  margin-bottom: 4px;\n}\n\n.form-error {\n  color: #a4262c;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n/* Actions */\n.actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.actions-row {\n  display: flex;\n  gap: 8px;\n}\n\n/* Muted text */\n.muted {\n  color: #8a8886;\n  font-size: 12px;\n}\n\n/* Help text */\n.help-text {\n  background-color: #f3f2f1;\n  padding: 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #605e5c;\n  margin-top: 16px;\n}\n\n/* AI Assistant */\n.ai-assistant {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.result-box {\n  background-color: #f3f2f1;\n  border-radius: 4px;\n  padding: 12px;\n}\n\n.result-box textarea {\n  width: 100%;\n  font-size: 13px;\n}\n\n/* Correction Preview */\n.correction-preview {\n  background-color: #f3f2f1;\n  border-radius: 4px;\n  padding: 12px;\n}\n\n.correction-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 12px;\n}\n\n.correction-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #323130;\n}\n\n.correction-summary {\n  font-size: 11px;\n  color: #605e5c;\n}\n\n.correction-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.correction-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 8px;\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid #edebe9;\n  cursor: pointer;\n  transition: background-color 0.15s;\n}\n\n.correction-item:hover {\n  background-color: #f5f5f5;\n}\n\n.correction-item.invalid {\n  opacity: 0.7;\n  cursor: not-allowed;\n  background-color: #fde7e9;\n  border-color: #d13438;\n}\n\n.correction-item.valid {\n  border-left: 3px solid #107c10;\n}\n\n.correction-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.correction-text {\n  font-size: 13px;\n  color: #323130;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n}\n\n.correction-text .original {\n  background-color: #fde7e9;\n  color: #a4262c;\n  padding: 2px 6px;\n  border-radius: 3px;\n  text-decoration: line-through;\n}\n\n.correction-text .arrow {\n  color: #8a8886;\n  font-size: 12px;\n}\n\n.correction-text .corrected {\n  background-color: #dff6dd;\n  color: #107c10;\n  padding: 2px 6px;\n  border-radius: 3px;\n}\n\n.correction-meta {\n  margin-top: 4px;\n  font-size: 11px;\n}\n\n.correction-meta .meta-valid {\n  color: #605e5c;\n}\n\n.correction-meta .meta-invalid {\n  color: #a4262c;\n}\n\n.correction-info {\n  padding: 8px;\n  background-color: #c0e8d0;\n  border-radius: 4px;\n}\n\n.correction-actions {\n  padding-top: 8px;\n  border-top: 1px solid #edebe9;\n}\n\n/* Modal-specific styles */\n.correction-list-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 4px;\n}\n\n.correction-list-modal .correction-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px;\n  background-color: #fafafa;\n  border-radius: 6px;\n  border: 1px solid #edebe9;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.correction-list-modal .correction-item:hover {\n  background-color: #f0f0f0;\n  border-color: #d0d0d0;\n}\n\n.correction-list-modal .correction-item.valid {\n  border-left: 4px solid #107c10;\n}\n\n.correction-list-modal .correction-item.invalid {\n  opacity: 0.8;\n  cursor: not-allowed;\n  background-color: #fff5f5;\n  border-color: #f0c0c0;\n}\n\n.correction-list-modal .correction-text {\n  font-size: 14px;\n  gap: 8px;\n}\n\n.correction-list-modal .correction-text .original {\n  padding: 4px 8px;\n  font-size: 13px;\n}\n\n.correction-list-modal .correction-text .corrected {\n  padding: 4px 8px;\n  font-size: 13px;\n}\n\n.correction-list-modal .correction-meta {\n  margin-top: 6px;\n  font-size: 12px;\n}\n\n/* Correction options (Track Changes checkbox) */\n.correction-options {\n  background-color: #f8f8f8;\n  border-radius: 4px;\n  padding: 8px 12px;\n}\n\n/* Tab Container - Underline minimalist */\n.tab-container {\n  margin: 0 0 8px 0;\n  border-bottom: 1px solid #e8e8e8;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.tab-logo {\n  height: 28px;\n  width: auto;\n  opacity: 0.7;\n  margin-right: 16px;\n  flex-shrink: 0;\n}\n\n.tab-container [role=\"tablist\"] {\n  gap: 0;\n}\n\n.tab-container [role=\"tab\"] {\n  border-radius: 0;\n  padding: 10px 16px;\n  font-weight: 500;\n  font-size: 13px;\n  color: #8a8886;\n  transition: all 0.15s ease;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  background: none;\n}\n\n.tab-container [role=\"tab\"]:hover {\n  background-color: transparent;\n  color: #485550;\n  border-bottom-color: #c8d5cc;\n}\n\n.tab-container [role=\"tab\"][aria-selected=\"true\"] {\n  background-color: transparent;\n  color: #009640;\n  border-bottom-color: #009640;\n  font-weight: 600;\n  box-shadow: none;\n}\n\n.tab-container [role=\"tab\"] svg,\n.tab-container [role=\"tab\"] span {\n  color: inherit !important;\n}\n\n/* Hide Fluent UI's built-in tab indicator */\n.tab-container [role=\"tab\"]::after {\n  display: none !important;\n}\n\n.tab-content {\n  flex: 1;\n  overflow-y: auto;\n}\n\n/* Tools Tab */\n.tools-tab {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Process Data Tab */\n.process-data-tab {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Chat Tab */\n.chat-tab {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 80px);\n  min-height: 0; /* Allow flex children to shrink */\n}\n\n.chat-messages {\n  flex: 1 1 0;\n  overflow-y: auto;\n  padding: 8px 4px;\n  padding-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-height: 0; /* Critical for flex scroll */\n  margin-bottom: 8px;\n  border-bottom: 1px solid #d8e2db;\n}\n\n/* Cards inside chat should not have internal scroll limits */\n.chat-messages .analysis-result-card,\n.chat-messages .tool-response-block {\n  flex-shrink: 0; /* Prevent cards from shrinking */\n}\n\n.chat-empty {\n  text-align: center;\n  padding: 16px;\n  color: #8a8886;\n  font-size: 12px;\n}\n\n.chat-empty p {\n  margin: 0;\n}\n\n.chat-message {\n  display: flex;\n  flex-direction: column;\n  padding: 10px 14px;\n  border-radius: 12px;\n  max-width: 85%;\n}\n\n.chat-message.user {\n  align-self: flex-end;\n  background-color: #009640;\n  color: #fff;\n  border-bottom-right-radius: 4px;\n}\n\n.chat-message.assistant {\n  align-self: flex-start;\n  background-color: #f3f2f1;\n  color: #323130;\n  border-bottom-left-radius: 4px;\n}\n\n.chat-message-content {\n  font-size: 13px;\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n/* Only apply pre-wrap to user messages (plain text) */\n.chat-message.user .chat-message-content {\n  white-space: pre-wrap;\n}\n\n.chat-message-time {\n  font-size: 10px;\n  opacity: 0.7;\n  margin-top: 4px;\n  align-self: flex-end;\n}\n\n.chat-input-area {\n  padding: 8px 12px 10px 12px;\n  background: linear-gradient(135deg, #f2f7f4 0%, #e8f0eb 100%);\n  border-radius: 12px;\n  margin-top: 4px;\n}\n\n.chat-input-resize-handle {\n  height: 10px;\n  cursor: ns-resize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  transition: background-color 0.15s;\n  margin-bottom: 4px;\n  border-radius: 6px;\n}\n\n.chat-input-resize-handle::after {\n  content: \"\";\n  width: 40px;\n  height: 3px;\n  background-color: #c0cec4;\n  border-radius: 2px;\n  transition: background-color 0.15s;\n}\n\n.chat-input-resize-handle:hover {\n  background-color: rgba(0, 150, 64, 0.1);\n}\n\n.chat-input-resize-handle:hover::after {\n  background-color: #009640;\n}\n\n.chat-input-row {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.chat-input-row textarea,\n.chat-input-row .fui-Textarea {\n  resize: none;\n  min-height: 36px;\n  max-height: 300px;\n  border-radius: 10px !important;\n  border-color: #c8d5cc !important;\n  background-color: #fff !important;\n}\n\n.chat-input-row textarea:focus,\n.chat-input-row .fui-Textarea:focus-within {\n  border-color: #009640 !important;\n  box-shadow: 0 0 0 1px rgba(0, 150, 64, 0.2) !important;\n}\n\n.chat-buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  align-items: center;\n}\n\n.chat-buttons button {\n  border-radius: 8px !important;\n  transition: all 0.15s ease !important;\n}\n\n/* Send button - brand green */\n.chat-buttons button[data-fui-focus-visible] {\n  outline-color: #009640 !important;\n}\n\n.chat-buttons > span:first-child button {\n  background-color: #009640 !important;\n  border-color: #009640 !important;\n}\n\n.chat-buttons > span:first-child button:hover:not(:disabled) {\n  background-color: #007A33 !important;\n  border-color: #007A33 !important;\n}\n\n.chat-buttons > span:first-child button:disabled {\n  background-color: #c0cec4 !important;\n  border-color: #c0cec4 !important;\n}\n\n/* Chat Selection Preview */\n.chat-selection-preview {\n  background-color: #f8faf9;\n  border: 1px solid #c8d5cc;\n  border-radius: 10px;\n  padding: 10px 12px;\n  margin-bottom: 8px;\n}\n\n.chat-selection-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 11px;\n  font-weight: 600;\n  color: #607060;\n  margin-bottom: 6px;\n}\n\n.chat-selection-text {\n  font-size: 12px;\n  color: #323130;\n  line-height: 1.4;\n  max-height: 80px;\n  overflow-y: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* Markdown Content in Chat - compact styling */\n.markdown-content {\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n/* Reset base margins */\n.markdown-content p,\n.markdown-content ul,\n.markdown-content ol,\n.markdown-content h1,\n.markdown-content h2,\n.markdown-content h3,\n.markdown-content h4,\n.markdown-content h5,\n.markdown-content h6 {\n  margin: 0;\n  padding: 0;\n}\n\n/* Paragraphs */\n.markdown-content p {\n  margin-bottom: 0.5em;\n}\n\n/* Lists */\n.markdown-content ul,\n.markdown-content ol {\n  padding-left: 1.5em;\n  margin: 0.5em 0;\n  list-style-position: outside;\n}\n\n.markdown-content li {\n  margin-bottom: 0.4em;\n  padding-left: 0.3em;\n}\n\n/* Nested lists (bullets) - more indentation */\n.markdown-content li > ul,\n.markdown-content li > ol {\n  margin: 0.2em 0;\n  padding-left: 1.8em;\n}\n\n/* Headings */\n.markdown-content h1,\n.markdown-content h2,\n.markdown-content h3 {\n  font-weight: 600;\n  margin: 0.6em 0 0.3em 0;\n}\n\n.markdown-content h1 { font-size: 15px; }\n.markdown-content h2 { font-size: 14px; }\n.markdown-content h3 { font-size: 13px; }\n\n/* Code */\n.markdown-content code {\n  background-color: rgba(0, 0, 0, 0.08);\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-family: \"Consolas\", \"Monaco\", monospace;\n  font-size: 12px;\n}\n\n.markdown-content pre {\n  background-color: rgba(0, 0, 0, 0.08);\n  padding: 8px;\n  border-radius: 4px;\n  overflow-x: auto;\n  margin: 0.5em 0;\n}\n\n.markdown-content pre code {\n  background: none;\n  padding: 0;\n}\n\n/* Other elements */\n.markdown-content blockquote {\n  border-left: 3px solid #8a8886;\n  margin: 0.5em 0;\n  padding-left: 10px;\n  color: #605e5c;\n}\n\n.markdown-content strong { font-weight: 600; }\n.markdown-content em { font-style: italic; }\n\n.markdown-content a {\n  color: #009640;\n  text-decoration: none;\n}\n\n.markdown-content a:hover {\n  text-decoration: underline;\n}\n\n.markdown-content hr {\n  border: none;\n  border-top: 1px solid #edebe9;\n  margin: 0.5em 0;\n}\n\n.markdown-content table {\n  border-collapse: collapse;\n  width: 100%;\n  margin: 0.5em 0;\n  font-size: 12px;\n}\n\n.markdown-content th,\n.markdown-content td {\n  border: 1px solid #edebe9;\n  padding: 4px 6px;\n  text-align: left;\n}\n\n.markdown-content th {\n  background-color: rgba(0, 0, 0, 0.05);\n  font-weight: 600;\n}\n\n/* Clickable citations [[text]] */\n.chat-citation {\n  background-color: #e0f2e8;\n  color: #009640;\n  padding: 1px 4px;\n  border-radius: 3px;\n  cursor: pointer;\n  border-bottom: 1px dashed #009640;\n  transition: background-color 0.15s, color 0.15s;\n}\n\n.chat-citation:hover {\n  background-color: #c0e8d0;\n  color: #007A33;\n}\n\n.chat-citation:active {\n  background-color: #a0d8b8;\n}\n\n/* Quick Actions - Chip style */\n.chat-quick-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 4px 0;\n  margin-bottom: 6px;\n}\n\n.quick-action-btn {\n  border-radius: 20px !important;\n  font-weight: 500 !important;\n  font-size: 11px !important;\n  transition: all 0.15s ease !important;\n  background-color: transparent !important;\n  border-color: #d8ddd9 !important;\n  color: #606060 !important;\n  padding: 3px 10px !important;\n  min-width: 0 !important;\n}\n\n.quick-action-btn:hover:not(:disabled) {\n  background-color: #f0f5f2 !important;\n  border-color: #009640 !important;\n  color: #009640 !important;\n}\n\n.quick-action-btn:disabled {\n  opacity: 0.4 !important;\n}\n\n.quick-action-btn.active {\n  background-color: #e6f4ec !important;\n  border-color: #009640 !important;\n  color: #009640 !important;\n  font-weight: 600 !important;\n}\n\n.quick-action-btn.active:hover:not(:disabled) {\n  background-color: #d4eddf !important;\n  border-color: #007A33 !important;\n  color: #007A33 !important;\n}\n\n/* Analysis Result Card */\n.analysis-result-card {\n  background-color: #f8faf9;\n  border: 1px solid #d8e2db;\n  border-radius: 10px;\n  overflow: hidden;\n  margin: 8px 0;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n}\n\n.analysis-result-card.collapsed {\n  border-color: #d8e2db;\n}\n\n.analysis-result-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  background: linear-gradient(135deg, #e8f0eb 0%, #d8e2db 100%);\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.15s;\n}\n\n.analysis-result-header:hover {\n  background: linear-gradient(135deg, #d8e2db 0%, #d0ddd4 100%);\n}\n\n.analysis-result-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #485550;\n}\n\n.analysis-result-title svg {\n  color: #607060;\n}\n\n.analysis-result-time {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 10px;\n  font-weight: 400;\n  color: #8a8886;\n  margin-left: 4px;\n}\n\n.analysis-result-time svg {\n  width: 12px;\n  height: 12px;\n}\n\n.analysis-result-toggle {\n  color: #8a8886;\n  display: flex;\n  align-items: center;\n}\n\n.analysis-result-preview {\n  padding: 8px 14px;\n  font-size: 11px;\n  color: #605e5c;\n  background-color: #f8faf9;\n  border-top: 1px solid #e8f0eb;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Analysis Section */\n.analysis-section {\n  border-top: 1px solid #e8f0eb;\n}\n\n.analysis-section-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  background-color: #f8faf9;\n  cursor: pointer;\n  user-select: none;\n}\n\n.analysis-section-header:hover {\n  background-color: #f2f7f4;\n}\n\n.analysis-section-toggle {\n  color: #7a8a80;\n  display: flex;\n  align-items: center;\n}\n\n.analysis-section-title {\n  font-size: 12px;\n  font-weight: 500;\n  color: #485550;\n}\n\n/* Apply All button - brand green */\n.analysis-apply-all-btn {\n  background-color: #009640 !important;\n  border-color: #009640 !important;\n  color: #fff !important;\n}\n\n.analysis-apply-all-btn:hover {\n  background-color: #007A33 !important;\n  border-color: #007A33 !important;\n}\n\n.analysis-apply-all-btn:active {\n  background-color: #006528 !important;\n  border-color: #006528 !important;\n}\n\n.analysis-section-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 12px;\n  background-color: #fff;\n}\n\n/* paragraph-groups inside analysis-section - no internal scroll, grows naturally */\n.analysis-section-content.paragraph-groups {\n  padding: 12px;\n  padding-bottom: 8px;\n  /* No max-height - scroll is at chat level */\n}\n\n/* Custom scrollbar for chat messages area */\n.chat-messages::-webkit-scrollbar {\n  width: 8px;\n}\n\n.chat-messages::-webkit-scrollbar-track {\n  background: #e8f0eb;\n  border-radius: 4px;\n}\n\n.chat-messages::-webkit-scrollbar-thumb {\n  background: #b8c8be;\n  border-radius: 4px;\n  min-height: 40px;\n}\n\n.chat-messages::-webkit-scrollbar-thumb:hover {\n  background: #98b0a0;\n}\n\n/* Analysis Item (generic) */\n.analysis-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 12px;\n  margin-bottom: 8px;\n  background-color: #fafafa;\n  border-radius: 6px;\n  border-left: 3px solid #e0e0e0;\n}\n\n.analysis-item.erro {\n  border-left-color: #d13438;\n}\n\n.analysis-item.melhoria {\n  border-left-color: #498205;\n}\n\n.analysis-item:last-child {\n  margin-bottom: 0;\n}\n\n.analysis-item.applied {\n  opacity: 0.5;\n  background-color: #f0fff0;\n}\n\n.analysis-item-content {\n  flex: 1;\n  min-width: 0;\n}\n\n/* Type badge (erro/melhoria) - elegant pill style */\n.analysis-type-badge {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n\n.analysis-type-badge.erro {\n  color: #fff;\n  background: linear-gradient(135deg, #d13438, #a4262c);\n}\n\n.analysis-type-badge.melhoria {\n  color: #fff;\n  background: linear-gradient(135deg, #498205, #107c10);\n}\n\n/* Count badges in section header - pill style */\n.analysis-count-badge {\n  display: inline-block;\n  font-size: 9px;\n  font-weight: 600;\n  margin-left: 6px;\n  padding: 2px 6px;\n  border-radius: 8px;\n}\n\n.analysis-count-badge.erro {\n  color: #fff;\n  background-color: #d13438;\n}\n\n.analysis-count-badge.melhoria {\n  color: #fff;\n  background-color: #498205;\n}\n\n.analysis-correction-text {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  flex-wrap: wrap;\n}\n\n.analysis-correction-text .original {\n  background-color: #fde7e9;\n  color: #a4262c;\n  padding: 2px 6px;\n  border-radius: 3px;\n  text-decoration: line-through;\n}\n\n.analysis-correction-text .arrow {\n  color: #8a8886;\n}\n\n.analysis-correction-text .corrected {\n  background-color: #dff6dd;\n  color: #107c10;\n  padding: 2px 6px;\n  border-radius: 3px;\n}\n\n.applied-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: #107c10;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.analysis-item-toggle {\n  color: #8a8886;\n  display: flex;\n  align-items: center;\n}\n\n.analysis-item-preview {\n  font-size: 12px;\n  color: #323130;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.analysis-item-details {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #edebe9;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.analysis-detail-row {\n  font-size: 12px;\n  color: #323130;\n  line-height: 1.4;\n}\n\n.analysis-detail-row.muted {\n  color: #605e5c;\n}\n\n.analysis-empty {\n  text-align: center;\n  padding: 16px;\n  color: #8a8886;\n  font-size: 12px;\n}\n\n/* Analysis List (style & legal sections) */\n.analysis-list {\n  list-style: none;\n  margin: 0;\n  padding: 8px 12px;\n  background-color: #fff;\n}\n\n.analysis-list-item {\n  font-size: 12px;\n  color: #323130;\n  line-height: 1.5;\n  padding: 6px 0;\n  border-bottom: 1px solid #f3f2f1;\n}\n\n.analysis-list-item:last-child {\n  border-bottom: none;\n}\n\n.analysis-clickable {\n  color: #009640;\n  cursor: pointer;\n  font-style: italic;\n}\n\n.analysis-clickable:hover {\n  text-decoration: underline;\n}\n\n.analysis-suggestion {\n  color: #107c10;\n  font-weight: 500;\n}\n\n.analysis-reason {\n  color: #605e5c;\n  font-size: 11px;\n}\n\n.analysis-reference {\n  color: #8a8886;\n  font-size: 11px;\n  font-style: italic;\n}\n\n/* Item header - badge + actions */\n.analysis-item-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.analysis-item-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: auto;\n}\n\n/* Locate button - subtle icon */\n.analysis-locate-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: transparent;\n  color: #605e5c;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.15s ease;\n}\n\n.analysis-locate-btn:hover {\n  background-color: #e1dfdd;\n  color: #009640;\n}\n\n.analysis-locate-btn:active {\n  background-color: #c8c6c4;\n}\n\n/* Explanation text - green highlight box */\n.analysis-explanation {\n  display: block;\n  font-size: 11px;\n  color: #2d5540;\n  background-color: #e8f5ed;\n  border-left: 2px solid #009640;\n  padding: 6px 10px;\n  margin-bottom: 8px;\n  border-radius: 0 4px 4px 0;\n}\n\n/* Visual diff - indented with bracket style */\n.analysis-diff-text {\n  font-size: 12px;\n  line-height: 1.6;\n  color: #323130;\n  padding-left: 12px;\n  border-left: 2px solid #e0e0e0;\n}\n\n/* Diff highlights - deletions (red strikethrough) */\n.analysis-diff-text del {\n  color: #a4262c;\n  background-color: #fde7e9;\n  text-decoration: line-through;\n  padding: 0 2px;\n  border-radius: 2px;\n}\n\n/* Diff highlights - insertions (green) */\n.analysis-diff-text ins {\n  color: #107c10;\n  background-color: #dff6dd;\n  font-weight: 500;\n  text-decoration: none;\n  padding: 0 2px;\n  border-radius: 2px;\n}\n\n/* ============================================\n   Paragraph Groups - Grouped corrections view\n   ============================================ */\n\n.paragraph-groups {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.paragraph-group {\n  background-color: #f8faf9;\n  border-radius: 10px;\n  border: 1px solid #d8e2db;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.paragraph-group.all-resolved {\n  opacity: 0.7;\n  background-color: #f8fbf8;\n  border-color: #d4e8d4;\n  box-shadow: none;\n}\n\n.paragraph-group-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  background: linear-gradient(135deg, #f2f7f4 0%, #ebf1ed 100%);\n  border-bottom: 1px solid #d8e2db;\n}\n\n.paragraph-group-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #323130;\n}\n\n.paragraph-group-count {\n  font-weight: 400;\n  color: #605e5c;\n  margin-left: 6px;\n}\n\n/* AI's explanation/summary for the paragraph */\n.paragraph-group-resumo {\n  font-size: 11px;\n  color: #2d5540;\n  background-color: #e8f5ed;\n  padding: 8px 12px;\n  border-bottom: 1px solid #d8e8dc;\n}\n\n/* Full paragraph diff display */\n.paragraph-group-diff {\n  font-size: 12px;\n  line-height: 1.6;\n  color: #323130;\n  padding: 12px;\n  background-color: #fff;\n  border-bottom: 1px solid #e8e8e8;\n}\n\n.paragraph-group-diff del {\n  color: #a4262c;\n  background-color: #fde7e9;\n  text-decoration: line-through;\n  padding: 0 2px;\n  border-radius: 2px;\n}\n\n.paragraph-group-diff ins {\n  color: #107c10;\n  background-color: #dff6dd;\n  font-weight: 500;\n  text-decoration: none;\n  padding: 0 2px;\n  border-radius: 2px;\n}\n\n/* Individual corrections container */\n.paragraph-group-corrections {\n  padding: 10px 14px;\n  background-color: #f7f9f8;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-height: 40px;\n}\n\n/* Compact row for each individual correction */\n.compact-ajuste-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: linear-gradient(135deg, #f5fbf7 0%, #eef8f1 100%);\n  border-radius: 6px;\n  border: 1px solid #d8e8dc;\n  box-shadow: 0 1px 3px rgba(0, 150, 64, 0.08);\n  transition: all 0.2s ease;\n  min-height: 36px;\n}\n\n.compact-ajuste-row:hover {\n  border-color: #a8d4b8;\n  box-shadow: 0 2px 6px rgba(0, 150, 64, 0.12);\n}\n\n.compact-ajuste-row.applied {\n  opacity: 0.6;\n  background: linear-gradient(135deg, #f8fcf8 0%, #f0f8f0 100%);\n  border-color: #d4e8d4;\n  box-shadow: none;\n}\n\n.compact-ajuste-number {\n  font-size: 10px;\n  color: #609070;\n  font-weight: 600;\n  min-width: 20px;\n  flex-shrink: 0;\n  text-align: center;\n}\n\n.compact-ajuste-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  cursor: pointer;\n  padding: 2px 4px;\n  border-radius: 4px;\n  transition: background-color 0.15s ease;\n}\n\n.compact-ajuste-content:hover {\n  background-color: rgba(0, 150, 64, 0.1);\n}\n\n.compact-ajuste-diff {\n  font-size: 12px;\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.compact-ajuste-motivo {\n  font-size: 10px;\n  color: #009640;\n  font-style: italic;\n  padding: 2px 6px;\n  background-color: rgba(0, 150, 64, 0.08);\n  border-radius: 3px;\n  display: inline-block;\n  margin-top: 2px;\n}\n\n.compact-ajuste-diff del {\n  color: #a4262c;\n  background-color: #fde7e9;\n  text-decoration: line-through;\n  padding: 0 2px;\n  border-radius: 2px;\n}\n\n.compact-ajuste-diff ins {\n  color: #107c10;\n  background-color: #dff6dd;\n  font-weight: 500;\n  text-decoration: none;\n  padding: 0 2px;\n  border-radius: 2px;\n}\n\n.compact-ajuste-action {\n  flex-shrink: 0;\n}\n\n.applied-badge-small {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  color: #107c10;\n  font-size: 12px;\n}\n\n.rejected-badge-small {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  color: #a4262c;\n  font-size: 12px;\n}\n\n.compact-ajuste-row.rejected {\n  opacity: 0.5;\n  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);\n  border-color: #e0e0e0;\n  box-shadow: none;\n}\n\n.compact-ajuste-row.rejected .compact-ajuste-diff {\n  text-decoration: line-through;\n  color: #999;\n}\n\n.compact-ajuste-row.rejected .compact-ajuste-diff del,\n.compact-ajuste-row.rejected .compact-ajuste-diff ins {\n  background: none;\n  color: #999;\n}\n\n.rejected-count {\n  color: #a4262c;\n  font-size: 10px;\n}\n\n/* Validation error state */\n.compact-ajuste-row.validation-error {\n  background: linear-gradient(135deg, #fff8f0 0%, #ffefe0 100%);\n  border-color: #f0c8a0;\n  opacity: 0.85;\n}\n\n.compact-ajuste-validation-error {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #d83b01;\n  font-size: 10px;\n  margin-top: 4px;\n}\n\n.compact-ajuste-validation-error svg {\n  flex-shrink: 0;\n}\n\n.validation-error-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  font-size: 14px;\n  cursor: help;\n}\n\n/* ============================================\n   Tool Response Blocks (Redigir/Reescrever)\n   ============================================ */\n\n.tool-response-block {\n  background-color: #f5f8f6;\n  border: 1px solid #d0dbd4;\n  border-radius: 10px;\n  overflow: hidden;\n  margin: 8px 0;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n}\n\n.tool-response-block.collapsed {\n  border-color: #d8e2db;\n}\n\n.tool-response-block.applied {\n  background-color: #f6fbf6;\n  border-color: #c8e0c8;\n}\n\n.tool-response-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  background: linear-gradient(135deg, #e8f0eb 0%, #d8e2db 100%);\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.15s;\n}\n\n.tool-response-header:hover {\n  background: linear-gradient(135deg, #d8e2db 0%, #d0ddd4 100%);\n}\n\n.tool-response-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #3a4d40;\n}\n\n.tool-response-title svg {\n  color: #009640;\n}\n\n.tool-response-time {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 10px;\n  font-weight: 400;\n  color: #8a8886;\n  margin-left: 8px;\n}\n\n.tool-response-time svg {\n  width: 12px;\n  height: 12px;\n}\n\n.tool-response-toggle {\n  color: #8a8886;\n  display: flex;\n  align-items: center;\n}\n\n.tool-response-preview {\n  padding: 8px 14px;\n  font-size: 11px;\n  color: #605e5c;\n  background-color: #f8faf9;\n  border-top: 1px solid #d8e8dc;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tool-response-content {\n  padding: 14px;\n  background-color: #fff;\n  border-top: 1px solid #d8e2db;\n}\n\n.tool-response-input {\n  font-size: 11px;\n  color: #8a8886;\n  margin-bottom: 10px;\n  padding: 6px 10px;\n  background-color: #f2f7f4;\n  border-radius: 4px;\n  border-left: 2px solid #a0c8b0;\n}\n\n.tool-response-input-label {\n  font-weight: 600;\n  margin-right: 6px;\n  color: #605e5c;\n}\n\n.tool-response-input-text {\n  color: #323130;\n}\n\n.tool-response-result {\n  font-size: 13px;\n  line-height: 1.6;\n  color: #323130;\n  white-space: pre-wrap;\n  word-break: break-word;\n  padding: 12px;\n  background-color: #f7faf8;\n  border-radius: 6px;\n  border: 1px solid #d8e2db;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.tool-response-html {\n  white-space: normal;\n}\n\n.tool-response-html h1,\n.tool-response-html h2,\n.tool-response-html h3 {\n  font-size: 13px !important;\n  margin: 8px 0 4px 0;\n  line-height: 1.4;\n}\n\n.tool-response-html h1 {\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.tool-response-html h2 {\n  font-weight: 600;\n}\n\n.tool-response-html p {\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 4px 0;\n  text-indent: 0 !important;\n}\n\n.tool-response-html blockquote {\n  font-size: 11px !important;\n  margin: 6px 0 6px 12px;\n  padding-left: 8px;\n  border-left: 2px solid #d8e2db;\n  color: #605e5c;\n  font-style: italic;\n}\n\n.tool-response-html ol,\n.tool-response-html ul {\n  font-size: 12px;\n  margin: 4px 0;\n  padding-left: 20px;\n}\n\n.tool-response-html li {\n  margin-bottom: 2px;\n}\n\n.tool-response-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #d8e2db;\n}\n\n/* Tool Mode Indicator */\n.tool-mode-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: linear-gradient(135deg, #e0f0e8 0%, #c8e0d0 100%);\n  border: 1px solid #009640;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  font-size: 12px;\n  color: #007030;\n}\n\n.tool-mode-indicator svg {\n  flex-shrink: 0;\n  color: #009640;\n}\n\n.tool-mode-indicator span {\n  flex: 1;\n}\n\n.tool-mode-indicator button {\n  flex-shrink: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
